var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRedeemError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 287.2 257.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffc557;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #ffc557;\n        stroke-miterlimit: 10;\n        stroke-width: 29.77px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M126.68,24.65L17.53,213.7c-7.52,13.03,1.88,29.31,16.92,29.31h218.29c15.04,0,24.45-16.28,16.92-29.31L160.52,24.65c-7.52-13.03-26.33-13.03-33.85,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.22,190.84c0-5.16,1.4-8.77,4.21-10.85,2.8-2.07,6.22-3.11,10.26-3.11s7.29,1.04,10.09,3.11c2.8,2.08,4.21,5.69,4.21,10.85s-1.4,8.49-4.21,10.68c-2.81,2.19-6.17,3.28-10.09,3.28s-7.46-1.09-10.26-3.28c-2.81-2.19-4.21-5.75-4.21-10.68ZM143.77,162.75h0c-5.61,0-10.24-4.39-10.53-10l-3.1-59.15c-.32-6.03,4.49-11.1,10.53-11.1h6.2c6.04,0,10.85,5.07,10.53,11.1l-3.1,59.15c-.29,5.6-4.92,10-10.53,10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRedeemError);
export default __webpack_public_path__ + "static/media/icon-redeem_error.b8884e01818f23d2c3704d086a20f934.svg";
export { ForwardRef as ReactComponent };